import BudgetIconOne from '@/assets/js/BudgetIconOne';
import BudgetIconTwo from '@/assets/js/BudgetIconTwo';
import BudgetIconThree from '@/assets/js/BudgetIconThree';

export const BUDGET_ICONS = [
  {
    id: 'icon-1',
    name: 'Icon1',
    component: BudgetIconOne
  },
  {
    id: 'icon-2',
    name: 'Icon2',
    component: BudgetIconTwo
  },
  {
    id: 'icon-3',
    name: 'Icon3',
    component: BudgetIconThree
  }
];

export const getIconById = (id: string) => BUDGET_ICONS.find((icon) => icon.id === id);

export const getIconComponent = (id: string) => {
  const icon = getIconById(id);
  return icon ? icon.component : BudgetIconOne;
};
